// import { yupResolver } from '@hookform/resolvers/yup'
// import { Textarea } from '@nextui-org/react'
// import { Auth } from 'aws-amplify'
import { NextSeo } from 'next-seo'
import { Fragment } from 'react'

// import AuthBg from '@/assets/illustrations/auth.svg'
// import bottomImg from '@/assets/illustrations/home.svg'
// import Button, { ButtonVariant } from '@/components/button'
// import Input from '@/components/input'
// import Link from '@/components/link'
// import handleApiError from '@/utils/handle-api-error'
// import ContactUs from '@/pages/contactUs'

const faqs = [
  {
    question: 'How do thrive skills help in making everyday emotions easy?',
    answer:
      'Each thrive skill has been designed to increase our awareness about our emotions in the context of the topic. In addition, they teach you methods to manage emotions constructively and effectively towards a goal using tools that are used regularly in psychotherapy. When you practise these methods regularly, they help you manage everyday emotions easily.',
  },
  {
    question: 'How much time do I need to spend to do well in this course?',
    answer:
      'The live sessions will need 45mins once a week for 4 weeks. In addition, we recommend you spend 10 minutes per day to practise the learnings in real life.',
  },
  {
    question: 'Is the course in English or Hindi or other Indian languages?',
    answer: 'Currently we are offering this course in English only.',
  },
  {
    question: 'How long will it take to get access of the course?',
    answer:
      'You will have access to each course from the start date of the course. Access to the resources will be available from the start time of the batch and will be available for repeat access anytime thereafter',
  },
  {
    question: 'What the frequency of live interaction in the course?',
    answer:
      'Live Interaction with the learning cohort happens once a week for 4 weeks',
  },
  {
    question: 'Can I take course from my city?',
    answer: 'Yes, it is a 100% online program, so you can attend from any city',
  },
  {
    question: 'What are the Thrive skills I can learn from this course?',
    answer:
      'We are building more a library of thrive skills that is beneficial for everyone. However for now, we have 3 that are live',
  },
  {
    question: 'What is the science behind these courses?',
    answer:
      'The foundation for all courses is based in proven scientific models, frameworks and assessments. Thrive Café uniquely creates a methodology to apply these into our everyday lives',
  },
  {
    question: 'What are the topics which will be covered in this course?		',
    answer:
      'The main takeouts from each course can be accesses through the course page (add link)',
  },
  {
    question:
      'Can I sign up for only for a few sessions that I am interested in?',
    answer:
      'All course are designed to offer integrated learning across sessions. We do not offer optional choice of sessions. ',
  },
  {
    question: 'Can I change my batch after signing up for the course?',
    answer:
      'As of now, we do not have this open available. But we are working on it',
  },
  {
    question: 'Can I join a batch once it has started?',
    answer:
      'It is not recommended to join a batch once it has started. We recommend you find the next available batch. Or write to us on talk2us@thrivecafe.in',
  },
  {
    question:
      'Will I able to watch previous classes of a batch once it has started?',
    answer:
      'yes, all views of attended sessions are available for re-viewing in the Resources section (add link)',
  },
  {
    question: 'Can I join multiple batches at once?',
    answer:
      'You can sign up for multiple courses at once. However we recommend that you schedule one course at a time for you to gain the maximum for each course',
  },
  {
    question: 'Will I get a certificate of completion?',
    answer:
      'We will be issuing a certificate of completion. It will be emailed to you at your registered email ID withing 10 days of course completion',
  },
  {
    question:
      'Why do I need to attend a batch? Why not anytime learning when it’s convenient for me?',
    answer:
      'Research has shown that we learn best with other people. Hence all Thrive Café courses are designed to learn with other people, hence the need for a batch. ',
  },
  {
    question: 'What do you mean by tech based enhanced learning?',
    answer:
      'Tech based enhanced learning means, the quality of learning is superior to regular f2f learning. Thrive Café delivers enhanced learning by integrating different formats of content that best help in effective learning like videos, discussion rooms, exercises for reflection, recap quizzes, assessments and assisted journaling. ',
  },
]

const FAQ = () => {
  return (
    <div className='flex h-[100%] min-h-full flex-wrap items-center bg-theme-turquoise px-5'>
      <NextSeo title='FAQ' />
      <div className='h-bg-intr custom-page mt-[50px] flex-[0_0_100%]'>
        <div className='relative'>
          <ul className='custom-heading list-[circle]'>
            <li className=''>
              <h1 className='font-normal uppercase'>FAQ</h1>
            </li>
          </ul>
          <div className='faqs-container pb-4'>
            {faqs.map((faq) => (
              <Fragment key={faq.question}>
                <details className='faqs'>
                  <summary className='custom-question font-normal text-[#000000]'>
                    {` ${faq.question}`}
                  </summary>
                  <div className='prose prose-sm max-w-none pl-3 text-[#333333]'>
                    <p className='custom-answer'>{faq.answer}</p>
                  </div>
                </details>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
      {/* heading - 24, 37, 25
          question - 18, 25, 25
          question - space - 50
          answer - 18, 14.4, 25
          answer- space - 33
       */}
      <style jsx>
        {`
          details.faqs summary::marker {
            content: '+';
          }
          details[open].faqs summary::marker {
            content: '-';
          }
          .custom-page {
            padding-inline: calc(
              30px + (500 - 30) * (100vw - 375px) / (1920 - 375)
            );
          }
          .custom-heading {
            font-size: calc(12pt + (48 - 12) * (100vw - 375px) / (1920 - 375));
            margin-top: calc(
              50px + (155 - 50) * (100vw - 375px) / (1920 - 375)
            );
            margin-left: calc(
              18px + (38 - 18) * (100vw - 375px) / (1920 - 375)
            );
          }
          @media (max-width: 767px) {
            .custom-heading {
              margin-left: 14px;
            }
          }
          .custom-question,
          .custom-answer {
            font-size: calc(9pt + (27 - 9) * (100vw - 375px) / (1920 - 375));
            line-height: calc(
              12pt + (36 - 12) * (100vw - 375px) / (1920 - 375)
            );
            margin-top: calc(20px + (60 - 20) * (100vw - 375px) / (1920 - 375));
          }
          .custom-answer {
            font-weight: 300;
            margin-top: 0;
            margin-bottom: calc(
              17px + (34 - 17) * (100vw - 375px) / (1920 - 375)
            );
          }
          .faqs-container {
            margin-bottom: calc(
              111.9pt + (335.7 - 111.9) * (100vw - 375px) / (1920 - 375)
            );
          }
        `}
      </style>
    </div>
  )
}
export default FAQ
